import React from 'react';
import get from 'lodash/get';
import { OffsetConsumer } from '../../../contexts/OffsetContext';
import Column from '../../../styles/Grid/Column';
import { SafePureComponent } from '../../../utils/SafePureComponent';

/**
 * Component needed to apply an amount of offset on lg and xl.
 * Needs OffsetProvider as parent to take the offset.
 */
class OffsetColumn extends SafePureComponent {
  safeRender() {
    const { props } = this;
    return (
      <OffsetConsumer>
        {({ offsetLeft }) => {
          const { offsets = {} } = props;
          const columnProps = offsetLeft
            ? {
                ...props,
                offsets: {
                  ...offsets,
                  lg: get(offsets, 'lg', 0) + offsetLeft,
                  xl: get(offsets, 'xl', 0) + offsetLeft,
                },
              }
            : props;

          return <Column {...columnProps} />;
        }}
      </OffsetConsumer>
    );
  }
}

OffsetColumn.displayName = 'OffsetColumn';

export default OffsetColumn;
